module.exports = __webpack_public_path__ + "static/media/july_2025_4.561389c1.webp";